import { render, staticRenderFns } from "./Kassa.vue?vue&type=template&id=58900628"
import script from "./Kassa.vue?vue&type=script&lang=js"
export * from "./Kassa.vue?vue&type=script&lang=js"
import style0 from "./Kassa.vue?vue&type=style&index=0&id=58900628&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports